import React, { Fragment, useEffect, useState } from 'react'
import './QuestionContainer.scss'
import { useIntl } from 'react-intl'
import Question from '../Question/Question'
import ActionItemContainer from '../../../UI/ActionItemContainer/ActionItemContainer'
import ActionItemDone from '../ActionItemDone/ActionItemDone'
import { Question as IQuestion } from '@/app/models/new-activity-creation-state'

const QuestionContainer = (props) => {
    const {
        questionList,
        onAddQuestion,
        onUpdateAnswer,
        onRemoveAnswer,
        onQuestionSave,
        onQuestionEdit,
        onQuestionRemove,
        onQuestionReduce,
        isDisabled,
    } = props
    const intl = useIntl()
    const [showAddLink, setAddLink] = useState(false)

    const onAddQuestionHandler = () => {
        onAddQuestion(questionList.length, {
            type: null,
            text: '',
            attachmentList: [],
            mandatoryAttachment: false,
            answerList: [],
        })
        setAddLink(true)
    }
    const onQuestionSaveHandler = (index: number, question: Partial<IQuestion>) => {
        setAddLink(false)
        onQuestionSave(index, question)
    }
    const onQuestionEditHandler = (index: number) => {
        onQuestionEdit(index, { isEdit: true })
        setAddLink(true)
    }
    const onQuestionReduceHandler = (index: number, question: Partial<IQuestion>) => {
        setAddLink(false)
        onQuestionReduce(index, question)
    }

    return (
        <ActionItemContainer
            hasItems={questionList.length > 0}
            showAddLink={showAddLink || isDisabled}
            onAddItem={() => onAddQuestionHandler()}
            title={intl.formatMessage({
                id: 'modals.new.activity.section.action.item.title.question',
                defaultMessage: 'Add question',
            })}>
            {questionList.map((question, index) => (
                <Fragment key={index}>
                    {question.isDone && !question.isEdit && (
                        <ActionItemDone
                            title={intl.formatMessage(
                                {
                                    id: 'modals.new.activity.section.action.question.done',
                                    defaultMessage: 'Saved question is here',
                                },
                                { index: index + 1 }
                            )}
                            onEdit={() => onQuestionEditHandler(index)}
                            onRemove={() => onQuestionRemove(index)}
                        />
                    )}
                    {(!question.isDone || question.isEdit) && (
                        <Question
                            form={question}
                            title={intl.formatMessage(
                                {
                                    id: 'modals.new.activity.section.action.question.title',
                                    defaultMessage: 'Question',
                                },
                                { index: index + 1 }
                            )}
                            onQuestionSave={(question) => onQuestionSaveHandler(index, question)}
                            onUpdateAnswer={(answerIndex, answer, disabled) =>
                                onUpdateAnswer(index, answerIndex, answer, disabled)
                            }
                            onRemoveAnswer={(answerIndex) => onRemoveAnswer(index, answerIndex)}
                            onReduce={() => onQuestionReduceHandler(index, question)}
                            disabled={isDisabled}
                        />
                    )}
                </Fragment>
            ))}
        </ActionItemContainer>
    )
}

export default QuestionContainer
